import { useEffect, useState } from "react";

/**
 * Preloads an image off-DOM and reports when it has finished loading (or
 * errored), so callers can gate rendering to avoid a pop-in of the image.
 */
export const useImagePreloaded = (source: string): boolean => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const image = new Image();
    const markReady = () => setIsReady(true);
    image.onload = markReady;
    image.onerror = markReady;
    image.src = source;
    if (image.complete) {
      markReady();
    }
  }, [source]);

  return isReady;
};
